module.exports = __webpack_public_path__ + "images/jacob-kettner.jpg";